<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <div
      class="image-uploader-body mx-3 clickable draggable-area"
      :class="`${multiple || images.length == 0 ? '' : 'single-image-body'}`"
      style="height: 494px; justify-content: start;"
    >
      <div class="d-flex justify-content-center align-items-center">
        <input
          ref="upload"
          type="file"
          class="draggable-input"
          accept="image/png, image/jpeg, video/mp4, image/webp"
          :multiple="multiple"
          :disabled="uploading"
          @change="readFiles"
          @drop="dragend"
          @dragend="dragend"
          @dragexit="dragend"
          @dragleave="dragend"
          @dragenter="dragenter"
        >
      </div>
      <template v-if="images.length === 0">
        <div class="blank-form">
          <base-icon
            icon="add-image"
            class="icon-position"
            @click.stop="select"
          />
        </div>
        <div
          class="image-upload__text"
          :class="'blank-form'"
          @click.stop="select"
        >
          <!-- <strong>Upload an image</strong> to add to your Edit -->
          Drag and drop or <u style="color: #0060DF">browse</u> to choose a file
        </div>
      </template>
      <div
        v-else
        class="d-flex thumbs-area d-flex flex-wrap"
        style="gap: 15px"
      >
        <div v-if="images.length === 1" class="grid-container">
          <div class="grid-item">
            <img
              v-if="images[0].src != ''"
              :src="images[0].src"
              class="mb-2 multiple-img clickable"
              alt=""
            >
          </div>
        </div>
        <div
          v-else
          :key="`image_upload_${index}`"
          class="thumb-wrap clickable"
          style="width: 100% !important;"
          @click="onSelectItem(index)"
        >
          <div class="row">
            <div
              v-for="(item, index) in images"
              class="col-sm-6 col-md-4 col-lg-3"
              style="padding-bottom: 24px;"
            >
              <img
                class="multiple-img"
                :src="item.src"
                :class="`${!item.selected ? 'transparent' : ''}`"
              >
              <base-loading
                :show="!item.src || item.src.length === 0"
                label=""
                class="loading-thumb"
              />
            </div>
          <!-- <base-icon
            :class="`selected-icon ${item.selected ? 'show' : ''}`"
            icon="selected"
          /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageUploader64',
  props: {
    value: {
      type: [String, Array],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: [],
      dragging: false,
      // TODO: Do something with this
      uploading: false,
    };
  },
  computed: {
    toUpload() {
      return this.images.filter((item) => item.selected);
    },
  },
  watch: {
    value: {
      handler(newval) {
        this.images = newval;
      },
      deep: true,
    },
    images: {
      handler(newval) {
        this.$emit('input', newval);
      },
      deep: true,
    },
  },
  methods: {
    dragend() {
      this.dragging = false;
    },
    dragenter() {
      if (this.uploading) return;
      this.dragging = true;
    },
    reset() {
      this.images = [];
    },
    select() {
      this.$refs.upload.click();
    },
    readFiles({ target: { files } }) {
      // append selected files
      const nItems = this.images.length;
      this.images = this.images.concat([...Array(files.length).keys()].map((index) => ({
        src: '',
        selected: true,
        file: null,
      })));
      const vm = this;

      // eslint-disable-next-line
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = function (event) {
          vm.images.splice(i + nItems, 1, { src: event.target.result, selected: true, file: files[i] });
        };

        reader.readAsDataURL(files[i]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.draggable-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  cursor: pointer;
}

.draggable-area {
  position: relative;
  height: 495px;
  overflow: auto;
}

.image-uploader-body {
  // background-color: $gray-light;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & > * {
    width: 100%;
    text-align: center;
  }
}

.image-upload{
  &__text{
    margin-top: 1rem;
    font-size: 16px;
    font-family: $font-family-sans-serif-light;
    strong{
      color: #E9AD7D;
    }
  }
}

// .image-preview {
//   height: 100%;
//   width: 100%;
//   object-fit: contain;
//   cursor: pointer;
// }

.grid-container {
  width: 100%;
  min-height: 500px;
  display: inline-grid;
  grid-template-columns: auto auto auto;
}

.grid-item {
  height: 180px;
  width: 400px;
}

.grid-container {
  width: 100%;
  min-height: 500px;
  display: inline-grid;
  grid-template-columns: auto auto auto;
}

.clickable {
  cursor: pointer;
}
.multiple-img {
  width: 100%;
  height: 100%;
  max-height: 180px;
  border-radius: 4px;
  object-fit: cover;
}
.blank-form{
  position: relative !important;
  top: 37% !important;
}
</style>
